import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { CalendarIcon } from "@gemini/icons";
import { useConfig } from "@/contexts/cdpConfig";
import { useTrackingBookVisit } from "@/hooks/tracking/useTrackingBookVisit";
export const BookVisitButton = ({ rootTestId, children, iconOnly = false, variant = "secondary", av_zone, ...props }) => {
    const isPreviewMode = useConfig().previewMode;
    const trackBookVisitClick = useTrackingBookVisit(av_zone);
    return (_jsx(Button, { size: iconOnly ? "40" : undefined, iconOnly: iconOnly, ...props, testId: `${rootTestId}.BookVisit`, variant: variant, icon: CalendarIcon, iconPosition: "start", isFullWidth: true, onPress: () => {
            var _a;
            trackBookVisitClick();
            (_a = window.$plato) === null || _a === void 0 ? void 0 : _a.open();
        }, isDisabled: isPreviewMode, children: children }));
};
